import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { SubSink } from 'subsink';
import { ApiHandlerService } from '../../core/api-handlers';
import { Logger } from '../../core/logger/logger.service';
import { PubSubService } from '../../core/services/pub-sub.service';
import { SwalService } from '../../core/services/swal.service';
import { ToastsService } from '../../core/services/toasts.service';
import { UtilityService } from '../../core/services/utility.service';
import { Socialusers } from '../../Models/socialusers';
import { AuthService } from './auth.service';
import { SocialAuthService } from 'angularx-social-login';

declare var $: any;
const log = new Logger('LogRegistrationComponent');

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
        const controlTouched = !!(control && (control.dirty || control.touched));
        const controlInvalid = !!(control && control.invalid);
        const parentInvalid = !!(control && control.parent && control.parent.invalid && (control.parent.dirty || control.parent.touched));

        return (controlTouched && (controlInvalid || parentInvalid));
    }
}

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})

export class AuthComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
    response;
    socialusers = new Socialusers();
    auth2: any;
    @ViewChild("loginRef") loginRef;
    private subSunk = new SubSink();
    showRegister: boolean = false;
    submittedLogin: boolean = false;
    submittedReg: boolean = false;
    submittedPwd: boolean = false;
    loginForm: FormGroup;
    regConfig: FormGroup;
    forgotPwdForm: FormGroup;
    returnUrl: string;
    errorMessage = '';
    loading = false;
    terms: boolean = false;
    registerClick:boolean=false;
    minDate: any;
    dobMinDate = new Date(new Date().getFullYear() - 18, new Date().getMonth(), 0)
    today;
    errMsg = '';
    phoneCodes: Array<any> = [];
    forgotPassMsg: string = "";
    isMatched: boolean = false
    bsDateConf: Partial<BsDatepickerConfig> = {
        isAnimated: true,
        dateInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-blue'//'theme-default',
    };
    titles: any;
    VerifyOtpForm:FormGroup;
    showOtpComponent = false;
    loginId:any;
    loginComoponent:boolean =false;
    config = {
        allowNumbersOnly: true,
        length: 6,
        isPasswordInput: false,
        disableAutoFocus: false,
        placeholder: '',
        inputStyles: {
            'width': '50px',
            'height': '50px'
        }
    };
    loginUser: any;
    passwordVisible:boolean = false;
    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router,
        private swalService: SwalService,
        private toastService: ToastsService,
        private pubSubService: PubSubService,
        private apiHandlerService: ApiHandlerService,
        private cdr: ChangeDetectorRef,
        private util: UtilityService,
        private socialAuthService: SocialAuthService
    ) {
    }

    ngOnInit(): void {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user-management/dashboard';
        this.crateLogin();
        this.createForm();
        this.submitOtp();
        this.createForgotPwdForm();
        this.getPhoneCodeList();
        this.getTitleList();
        this.socialAuthService.authState.subscribe((user) => {
            if (user && (user.provider === 'GOOGLE' || user.provider === 'FACEBOOK')) {
                let req = {
                    first_name: user.firstName,
                    last_name: user.lastName,
                    email: user.email,
                    id: user.id,
                    login_type: user.provider.toLowerCase()
                }
                this.loginWithSocialMedia(req);
            }
            else{
            sessionStorage.setItem('b2cUser', JSON.stringify(user));
            this.authService.currentUserSubject.next(JSON.parse(sessionStorage.getItem('b2cUser')));
            if (this.router.url == "flight/guest-details" || this.router.url.startsWith('/flight/guest-details') ||
                this.router.url == "flight-confirmr" || this.router.url.startsWith('/flight-confirm')) {
                $("#show_log").modal('hide');
                this.swalService.alert.success("Logged in Sucesss");
            } else {
                $("#show_log").modal('hide');
                this.router.navigate([this.returnUrl]);
            }
        }
        });
    }

    crateLogin() {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100), Validators.pattern(this.util.regExp.email)]],
            password: ['', [Validators.required]],
        });
    }

    getPhoneCodeList() {
        this.subSunk.sink = this.apiHandlerService.apiHandler('phoneCodeList', 'POST')
            .subscribe(res => {
                if (res && res.data.length) {
                    this.phoneCodes = res.data;
                    this.cdr.detectChanges();
                }
            });
    }


    onUpdatePassenges(phonecode: any) {
        phonecode = phonecode.split(/[()]/)[1];
        const result = this.phoneCodes.find(c => c.phone_code == phonecode);
        this.regConfig.patchValue({
            country: result.phone_code,
        });
    }

    getTitleList() {
        this.apiHandlerService.apiHandler('userTitlelist', 'POST')
            .subscribe(res => {
                if (res) {
                    this.titles = res.data;
                }
            });
    }

    createForgotPwdForm() {
        this.forgotPwdForm = this.fb.group({
            email: ['', [Validators.required, Validators.pattern(this.util.regExp.email)]],
            phone: ['', [Validators.pattern('(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})')]],
        })
    }

    atLeastOnePhoneRequired(group: FormGroup): { [s: string]: boolean } {
        if (group) {
            if (group.controls['email'].value || group.controls['phone'].value) {
                return null;
            }
        }
        return { 'error': true };
    }

    checkValid() {
        if (this.forgotPwdForm.get('phone').valid || this.forgotPwdForm.get('email').valid) {
            return false;
        } else {
            return true;
        }
    }

    keyPress() {
        if (this.forgotPwdForm.get('phone').valid || this.forgotPwdForm.get('email').valid) {
            this.errMsg = ''
        } else {
            this.errMsg = 'Please provide either of the valid field'
        }
    }

    forgotPassword() {
        this.submittedPwd = true
        if (this.forgotPwdForm.invalid)
            return;
        this.errMsg = '';
        this.apiHandlerService.apiHandler('forgotPassword', 'post', {}, {}, this.forgotPwdForm.value)
            .subscribe(resp => {
                if (resp.statusCode == 200 || resp.statusCode == 201) {
                    this.forgotPassMsg = "Reset Password link has been sent your email,Please check";

                    this.cdr.detectChanges();
                } else {
                    this.toastService.toast({ type: "error", text: "Something went wrong!!, please try later" })
                }
            })
    }

    onLogin() {
        this.submittedLogin = true;
        if (this.loginForm.invalid) {
            return;
        }
        this.authService.onLogin(this.loginForm.get('email').value, this.loginForm.get('password').value)
            .subscribe(res => {
                if (res['statusCode'] == 200 && res['data']['access_token'] != undefined) {
                    this.loginId = res['data']['id'];
                    this.loginUser = res.data;
                    this.errorMessage = '';
                    // sessionStorage.setItem('b2cUser', JSON.stringify(res.data));
                    // this.authService.currentUserSubject.next(JSON.parse(sessionStorage.getItem('b2cUser')));
                    if (this.router.url == "flight/guest-details" || this.router.url.startsWith('/flight/guest-details') ||
                        this.router.url == "flight-confirm" || this.router.url.startsWith('/flight-confirm')){
                        $("#show_log").modal('hide');
                   
                        this.swalService.alert.success("Logged in Sucesss")
                    } else {
                        $("#show_log").modal('hide');
                        $("#show_otp").modal('show').addClass("fade");
                        //  this.router.navigate(["/"]);
                        //  this.showOtpComponent = true;
                    }
                    // this.toastService.toast({ 'type': 'success', 'text': 'Logged in successfully' });
                } else {
                    this.errorMessage = res.Message;
                    this.toastService.toast({ 'type': 'error', 'text': this.errorMessage })
                }
                this.loading = false;
            }, (err) => {
                if (err.error.statusCode == 403 || err.error.statusCode == 500 ) {
                    this.errorMessage = "Invalid Credentials";
                    this.toastService.toast({ 'type': 'error', 'text': this.errorMessage })
                }
                if (err.error.statusCode == 404 ) {
                    this.errorMessage = "User Not Found";
                    this.toastService.toast({ 'type': 'error', 'text': this.errorMessage })
                }
            });
    }

    hasError = (controlName: string, errorName: string) => {
        return ((this.submittedLogin || this.loginForm.controls[controlName].touched) && this.loginForm.controls[controlName].hasError(errorName));
    }

    forgotPwdError = (controlName: string, errorName: string) => {
        return ((this.submittedPwd || this.forgotPwdForm.controls[controlName].touched) && this.forgotPwdForm.controls[controlName].hasError(errorName));
    }

    regFormError = (controlName: string, errorName: string) => {
        return ((this.submittedReg || this.regConfig.controls[controlName].touched) && this.regConfig.controls[controlName].hasError(errorName));
    }


    createForm(): void {
        this.regConfig = this.fb.group({
            gender: new FormControl(''),
            middle_name:new FormControl(''),
            first_name: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.fullName)]),
            last_name: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.fullName)]),
            date_of_birth: new FormControl(''),
            address: new FormControl(''),
            city: new FormControl(''),
            state: new FormControl(''),
            zip: new FormControl(''),
            country: ['18', [Validators.required]],
            phone: new FormControl('', [Validators.required, Validators.pattern(this.util.regExp.phoneNo)]),
            email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100), Validators.pattern(this.util.regExp.email)]),
            password: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(8)]),
            confirm_password: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(8)]),
        })
    }

    isPasswordMatched() {
        if (this.regConfig.get('password').value === this.regConfig.get('confirm_password').value)
            this.isMatched = false;
        else
            this.isMatched = true;
    }

    onCreateClick() {
        this.showRegister = true;
    }

    onBack() {
        this.showRegister = false;
    }

    onRegister() {
        this.submittedReg = true;
        if (this.regConfig.invalid)
            return;

        this.registerClick=true;
        this.submittedReg = true;
        if (this.regConfig.invalid){
            this.registerClick = false;
            return;
        }
        if (!this.terms) {
            this.registerClick = false;
            return;
        }
        if (String(this.regConfig.get('password').value) !== String(this.regConfig.get('confirm_password').value)) {
            this.pubSubService.publish('formError', {
                class: 'alert alert-danger',
                msg: `Retype Password isn't matching with Password`,
                timeOut: 5000
            });
            return;
        }
        const optionalBody = {
            auth_role_id: 4, status: true, uuid: '', business_name: '', business_number: '', title: '', address: ''
        }
        const reqBody = Object.assign(optionalBody, this.regConfig.value);
        delete reqBody.confirm_password;
        delete reqBody.email_subscription;
        this.apiHandlerService.apiHandler('addUser', 'post', {}, {}, reqBody)
            //  .pipe(untilDestroyed(this))
            .subscribe(resp => {
                //   log.debug(resp);
                if (resp.statusCode == 200) {
                    this.onBack();
                    this.toastService.toast({ 'type': 'success', 'text': 'Registration successfull' });
                    this.regConfig.reset()
                    this.cdr.detectChanges();

                } else {
                    this.toastService.toast({ 'type': 'success', 'text': 'Registration successfull...' });
                }
            }, (err: HttpErrorResponse) => {
                log.error(err);
                const { error } = err;
                let msg = '';
                switch (error.statusCode) {
                    case 400:
                        msg = error.message;
                        break;
                    case 403:
                        msg = 'Oops! user already exist';
                        break;
                    default:
                        msg = 'Oops! Something went wrong, please retry later'
                        break;
                }
                this.pubSubService.publish('formError', {
                    class: 'alert alert-danger',
                    msg,
                    timeOut: 5000
                })
                this.toastService.toast({ 'type': 'error', 'text': 'Soomething went wrong.. pls try later' });
            })
    }

    ngAfterViewInit(): void {
        $(".open_register").click(function () {
            $(".for_sign_in").fadeOut(500, function () {
                $(".for_sign_up").fadeIn(500)
            })
        });

        $(".open_sign_in").click(function () {
            $(".for_sign_up").fadeOut(500, function () {
                $(".for_sign_in").fadeIn(500)
            })
        });

        $(".forgot_pasword").click(function () {
            $("#show_log").modal('hide')
            $("#show_pass").modal("show").addClass("fade");
        });

        $(".open_sign_in_window").click(function () {
            $("#show_pass").removeClass("fade").modal("hide");
            $("#show_log").modal('show').addClass("fade");
        });

        $(".frgotpaswrd").click(function () {
            $("#forgotpaswrdpop").modal();
        });
    }


    signInWithGoogle(): void {
        this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then(socialUser => {
            
        }).catch(data => {
            this.socialAuthService.signOut();
          });
    }


    loginWithSocialMedia(reqBody) {
        this.apiHandlerService.apiHandler('userLogin', 'post', {}, {}, reqBody)
            .subscribe(resp => {
                if (resp.statusCode == 200 || resp.statusCode == 201) {
                    // this.toastService.toast({ type: "success", text: "Logged in successfully.." })
                    let socialUser = resp.data
                    sessionStorage.setItem('b2cUser', JSON.stringify(socialUser));
                    this.authService.currentUserSubject.next(JSON.parse(sessionStorage.getItem('b2cUser')));
                    if (this.router.url == "flight/guest-details" || this.router.url.startsWith('/flight/guest-details') ||
                        this.router.url == "flight-confirm" || this.router.url.startsWith('/flight-confirm')) {
                        $("#show_log").modal('hide');
                        this.swalService.alert.success("Logged in Sucesss");
                    } else {
                        $("#show_log").modal('hide');
                        this.router.navigate([this.returnUrl]);
                    }
                } else {
                    this.toastService.toast({ type: "error", text: "Something went wrong!!, please try later" })
                }
            }, (err: HttpErrorResponse) => {
                this.toastService.toast({ type: "error", text: "Something went wrong!!, please try later" })

            })
    }

    signInWithFB(): void {
        this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then(socialUser => {
        });
    }

    signOut(): void {
        this.socialAuthService.signOut();
    }

    ngOnDestroy(): void {
        this.subSunk.unsubscribe();
    }

    openStaticPage(page_title) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['cms/' + page_title])
        );
        window.open(  url, '_blank');
    }
    onTerms(e) {
        this.terms = e
    }
    onOtpChange(otp) {
        this.VerifyOtpForm.patchValue({ otpinput: otp });
    }
    otpverify(value) {
      // if (value.otpinput.length != 6) {
      //     return;
      // }
      this.loading = true;
      this.errorMessage = '';
      // let login_id = this.loginForm.get('employeeid').value;
      let otp = value.otpinput;
      // this.subSunk.sink = this.authService.validateDCBOTP(login_id, otp)
      //     .subscribe(res => {
        this.authService.validateOTP(this.loginId, otp)
        .subscribe(res => {
          if (res.statusCode == 200 || res.statusCode == 201) {
            if (this.router.url == "/hotel-guests" || this.router.url.startsWith('/hotel-guests')) {
              // If on /hotel-guests, just hide the modal
              $("#show_otp").modal('hide');
            } else {
              // If not on /hotel-guests, redirect to home
              $("#show_otp").modal('hide');
            //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //     this.router.navigate([decodeURI(this.router.url)]);
            //   });      
            this.router.navigate([this.router.url]);        
            }
      
            // Common operations after successful login
            sessionStorage.setItem('b2cUser', JSON.stringify(this.loginUser));
            this.authService.currentUserSubject.next(JSON.parse(sessionStorage.getItem('b2cUser')));
            this.swalService.alert.success("Logged in Successfully");
      
          } else {
            this.errorMessage = 'Invalid Credentials';
          }
          this.loading = false;
        }, (err) => {
            if (err.error.statusCode == 403 || err.error.statusCode == 500 ) {
                this.errorMessage = "Invalid OTP";
                this.toastService.toast({ 'type': 'error', 'text': this.errorMessage })
            }
            if (err.error.statusCode == 404 ) {
                this.errorMessage = "Something Went Wrong";
                this.toastService.toast({ 'type': 'error', 'text': this.errorMessage })
            }
        });      
    }
    submitOtp(): void {
      this.VerifyOtpForm = this.fb.group({
          otpinput: ['', [Validators.required]], //agent@provab.com
      });
    
    }
    requestAgain() {
      //  this.loginComoponent=true;
      this.ngOtpInput.setValue(''); // Assuming your component has a method like setValue to set its value
     this.onLogin()
    }
    back() {
      // this.isDCBLogin = true;
    //   this.loginComoponent =true;
    //   this.showOtpComponent = false;
    $("#show_log").modal('show').addClass("fade");
    $("#show_otp").modal('hide');
    }
    togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
      }

    closeSignUp() {
        $("#show_log").modal('hide');
    }
}